import React from 'react';
export function Footer() {
  return <footer className="bg-teal-975 text-cream/40 py-12 px-6 text-center text-sm border-t border-cream/5" data-id="element-80">
      <div className="max-w-4xl mx-auto" data-id="element-81">
        <p className="mb-4" data-id="element-82">
          © {new Date().getFullYear()} Freddy Pimentel. Todos los derechos
          reservados.
        </p>
        <p className="text-xs max-w-2xl mx-auto leading-relaxed opacity-60" data-id="element-83">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc. Los resultados
          pueden variar y dependen del compromiso individual de cada persona.
        </p>
      </div>
    </footer>;
}